import { useCallback, useMemo } from 'react'

import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { undoWorkingPolygon } from '../store'

const useUndo = () => {
  const dispatch = useAppDispatch()
  const workingPoints = useSelector((state: RootState) => state.bpToolPolygon.workingPoints)
  const canUndo = useMemo(() => !!workingPoints.length, [workingPoints])

  /**
   * Handles the undo action for the working polygon if exists.
   */
  const handleUndo = useCallback(() => {
    if (!canUndo) return

    dispatch(undoWorkingPolygon())
  }, [canUndo, dispatch])

  return {
    handleUndo,
    canUndo,
  }
}

export default useUndo
